import { jsx as _jsx } from "react/jsx-runtime";
import * as Components from '_components';
import * as Common from '_common';
export function ServerTagList(props) {
    const [tagsData] = useTags();
    return Common.renderServerData(tagsData, tags => (_jsx(TagList, { tags: tags, ...props })));
}
export function TagList(props) {
    const selectedTagIds = props.selectedTags?.map(Common.TagId) || [];
    const selectedTagsParsedIds = selectedTagIds.map(Common.parseTagId) ?? [];
    const tagsParsedIds = props.tags.map(t => Common.parseTagId(Common.TagId(t))) ?? [];
    function renderButton(tag) {
        if (props.useLink) {
            return (_jsx(Components.ButtonLink, { to: props.linkUrl ? props.linkUrl(tag) : '', isActive: selectedTagIds.includes(Common.TagId(tag)), children: _jsx("span", { children: _jsx(Components.MLT, { text: Common.TagName(tag, props.tagInfos || []) }) }) }, Common.TagId(tag)));
        }
        return (_jsx(Components.Button, { isActive: selectedTagIds.includes(Common.TagId(tag)), onClick: () => props.onClick && props.onClick(Common.TagId(tag)), children: _jsx("span", { children: _jsx(Components.MLT, { text: Common.TagName(tag, props.tagInfos || []) }) }) }, Common.TagId(tag)));
    }
    function renderTags(tags) {
        return (_jsx(Components.BtnGroup, { type: Components.BtnGroupType.Horizontal, children: Common.sortTags(tagsParsedIds)
                .filter(tagId => Common.displayInList(tagId, selectedTagsParsedIds))
                .map(renderButton) }));
    }
    return renderTags(props.tags);
}
function useTags() {
    const tagsData = Common.useServerData('/api/blog/tags');
    return [tagsData];
}
